var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplitTicketPayments = function SvgSplitTicketPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000115695 13.9835C0.909991 6.69045 6.69032 0.910143 13.9834 0.00025116V13.9835L0.000115695 13.9835Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00012207 18.0146C0.908983 25.3086 6.68969 31.0898 13.9834 31.9998V18.0146H-0.00012207Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0146 18.0146V32C25.3092 31.0909 31.0909 25.3092 32.0001 18.0146H18.0146Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 13.9835C31.0899 6.68978 25.3086 0.909079 18.0146 0V13.9835L31.9999 13.9835Z",
    fill: "currentColor"
  })));
};
export default SvgSplitTicketPayments;